module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/services/services.component.scss
// module id = ./src/app/services/services.component.scss
// module chunks = main